import { initVueAppOnLoad } from '@/app'
import App from '@/views/Itinerary.vue'
import router from 'app/javascript/src/routers/itinerary'

initVueAppOnLoad('#itinerary-page', App, async app => app.use(router))
